export defa mx-1  ult function maxTranslate() {
  return -this.snapGrid[this.snapGrid.length - 1];
}
